export const formatLastFundingType = (roundType: string) => {
  return roundType
    .replace('post_ipo', 'Post-IPO')
    .replace('pre_seed', 'Pre-Seed')
    .replace('non_equity', 'Non-equity')
    .split('_')
    .map((it) => it.charAt(0).toUpperCase() + it.slice(1))
    .join(' ')
}

export const toLowerCase = (roundType: string) => {
  return roundType
    .replace('Post-IPO', 'post_ipo')
    .replace('Pre-Seed', 'pre_seed')
    .replace('Non-equity', 'non_equity')
    .split(' ')
    .map((it) => it.charAt(0).toLowerCase() + it.slice(1))
    .join('_')
}
